<!-- パスが未使用の場合 -->
<template>
  <div :class="['footer', 'before-use', { 'standard-pass': props.isStandard }]">
    <!-- 使用前の注意書き -->
    <MPMSFaceBeforeUseCaution
      v-if="
        masterPass.content.description_json &&
        masterPass.content.description_json.BeforeUseCaution
      "
      :note="masterPass.content.description_json.BeforeUseCaution"
      :is-standard="props.isStandard"
    />
    <!-- 使用前の注意書き -->

    <div class="buttons">
      <!-- 期限内であれば使用開始できる -->
      <FaceStartButton
        v-if="props.isAvailablePeriod"
        :disabled="!props.isAvailablePeriod"
        button-label="このチケットの利用を開始する"
        :is-standard="props.isStandard"
        @clicked="openPassChangeToValidDialog"
      />

      <!-- 上記に当てはまらないため利用期間外-->
      <FaceStartButton
        v-else
        :disabled="!props.isAvailablePeriod"
        button-label="チケットの利用期間外です"
        :is-standard="props.isStandard"
      />
    </div>

    <!-- チケット有効化前の確認ダイアログ -->
    <DialogPassChangeToValid
      ref="DialogPassChangeToValid"
      :click-ok="passChangeToValid"
    />

    <ThePassDialogs :dialog-action="DialogAction" />
  </div>
</template>

<script>
// Vue
import { onMounted, computed, watchEffect, ref } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";

// Service
import bookService from "@/services/book";
import nativeHandlerService from "@/services/nativeHandler";
import myTicketsCommonService from "@/services/common/myTickets";

// API
import API from "@/API";

export default {
  name: "ThePassLowerBeforeValid",
  props: {
    isAvailablePeriod: {
      type: Boolean,
    },
    showIssueExternalCouponNotification: {
      type: Function,
      required: true,
    },
    isStandard: {
      type: Boolean,
      default: false,
    },
  },

  setup(props) {
    const store = useStore();
    const route = useRoute();

    const pass = computed(() => store.getters["ticketing/pass"]);
    const masterPass = computed(() => store.getters["ticketing/masterPass"]);

    const book = store.getters["ticketing/book"];
    const bookGroup = store.getters["ticketing/bookGroup"];
    const masterBook = store.getters["ticketing/masterBook"];

    let DialogAction = ref({ dialog: null, action: null });

    const DialogPassChangeToValid = ref(null);

    onMounted(async () => {
      if (route.query.fromQR) {
        openPassChangeToValidDialog();
      }
    });

    const openPassChangeToValidDialog = () => {
      DialogPassChangeToValid.value.openDialog();
    };

    const passChangeToValid = async () => {
      DialogPassChangeToValid.value.closeDialog();

      actionDialog("DialogLoading", true);

      // ブック自体を初めて使う場合はブックをvalidにする処理を挟む
      try {
        if (!book.is_valid) {
          await bookService.executeValidBooks(
            bookGroup,
            masterBook.is_multi_validatable
          );

          //issue external coupon when using pass ticket
          try {
            const numberCouponIssued = await API.issueExternalCoupon(
              masterBook.id,
              book.id
            );
            if (numberCouponIssued > 0) {
              props.showIssueExternalCouponNotification(true);
            }
          } catch (externalCouponError) {
            props.showIssueExternalCouponNotification(false);
            console.log("passChangeToValid :>> issue coupon fail");
          }
        }

        await API.getMyticketDetail(route.params.book_group_id);

        // パスの有効化
        const validPass = await API.validPasses(route.params.pass_id);

        nativeHandlerService.ncUsePass(
          masterBook.id,
          bookGroup.id,
          validPass,
          masterBook.start_hour
        );

        actionDialog("DialogLoading", false);
      } catch (err) {
        console.log("executeValidAPI err :>> ", err);
        errorHandring(err.response.data.error);
      }
    };

    const errorHandring = async (err) => {
      console.log("errorHandring :>> ", err);
      await actionDialog("DialogLoading", false);

      if (err == "valid_error_already_validated_another") {
        // PUT /books/:id/is_valid の同時利用エラーが valid_error_already_validated_another
        await actionDialog("DialogAlreadyValidatedAnother", true);
      } else if (err == "max_concurrent_using_over") {
        // POST /valid_books  の同時利用エラーが max_concurrent_using_over
        await actionDialog("DialogMaxConcurrentUsingOver", true);
      } else {
        // それ以外の理由でのデフォルトエラー
        console.log("object :>> passValid周りでエラー");
        // actionDialog("DialogValidPassFails", true)
      }
    };

    const actionDialog = (dialog, action) => {
      DialogAction.value = { dialog: dialog, action: action };
    };

    return {
      props,
      pass,
      masterPass,
      passChangeToValid,
      openPassChangeToValidDialog,
      DialogAction,
      DialogPassChangeToValid,
    };
  },
};
</script>

<style lang="scss" scoped>
.standard-pass {
  position: relative;
  height: auto;
  bottom: auto;
}
</style>
